import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { ScrollView, View } from 'react-native'

import {
  VFText,
  Card,
  Icon,
  Shimmer,
} from '@vfgroup-oneplatform/foundation/Components'
import {
  LightThemeColors,
  withTheme,
} from '@vfgroup-oneplatform/foundation/Components/Themes'
import { Calendar, LocaleConfig } from 'react-native-calendars'
import moment from 'moment'

import { getThemeImages } from '@vfgroup-oneplatform/framework/Themes'

import style from './DateStep.styles'

import {
  calendarLoadingConfig,
  bottomLoadingConfig,
  shimmerPlaceholderConfig
} from './DateStep.LoadingConfig'

LocaleConfig.locales.en = {
  monthNames: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ],
  monthNamesShort: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec'
  ],
  dayNames: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ],
  dayNamesShort: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  today: 'Today'
}
LocaleConfig.defaultLocale = 'en'

class DateStep extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedDate: '',
      selectedTime: '',
    }
  }
  componentDidMount() {
    const { selectedDate, selectedTime } = this.props
    this.setState({
      selectedDate: selectedDate ? moment(selectedDate).format('YYYY-MM-DD') : '',
      selectedTime: selectedTime ? selectedTime : '',
    })
  }
  formatDays = dates => {
    const keys = Object.keys(dates ?? {})
    const formattedData = {}
    for (let j = 0; j < keys.length; j++) {
      const key = moment(keys[j]).format('YYYY-MM-DD')
      formattedData[key] = dates[keys[j]]
    }
    return formattedData
  }
  renderTimeSlots = (dates, day, theme) => {
    const formattedData = this.formatDays(dates)
    const timeSlots = formattedData[day]
    return timeSlots?.map(timeSlot => (
      <View style={style.timeSlotContainerStyle}>
        <VFText
          i18nKey={timeSlot}
          style={style.timeSlotStyle(
            this.state.selectedTime === timeSlot,
            theme
          )}
          onPress={() => {
            this.setState({ selectedTime: timeSlot })
          }}
        />
      </View>
    ))
  }
  render() {
    const {
      theme,
      isLoading,
      onSelectDateAndTimePress,
      withTray,
    } = this.props
    const Images = getThemeImages(theme.name)
    return (
      <ScrollView
        showsHorizontalScrollIndicator={false}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={style.containerStyle(withTray)}
      >
        <VFText
          i18nKey={'book_appointment_date_step_title'}
          style={style.titleStyle(theme)}
        />
        <VFText
          i18nKey={'book_appointment_date_step_subtitle'}
          style={style.subTitleStyle(theme)}
        />
        <Card style={style.cardStyle(theme)}>
          {isLoading ? (
            <View style={style.cardContentStyle}>
              <Shimmer
                config={calendarLoadingConfig}
                shimmerPlaceholderConfig={shimmerPlaceholderConfig}
              />
              <View style={style.timeSlotsContainerLoadingStyle}>
                <View style={style.timeSlotContainerLoadingStyle}>
                  <View style={style.timeSlotLoadingStyle(theme)} />
                </View>
                <View style={style.timeSlotContainerLoadingStyle}>
                  <View style={style.timeSlotLoadingStyle(theme)} />
                </View>
                <View style={style.timeSlotContainerLoadingStyle}>
                  <View style={style.timeSlotLoadingStyle(theme)} />
                </View>
                <View style={style.timeSlotContainerLoadingStyle}>
                  <View style={style.timeSlotLoadingStyle(theme)} />
                </View>
                <View style={style.timeSlotContainerLoadingStyle}>
                  <View style={style.timeSlotLoadingStyle(theme)} />
                </View>
              </View>
              <Shimmer
                config={bottomLoadingConfig}
                shimmerPlaceholderConfig={shimmerPlaceholderConfig}
              />
            </View>
          ) : (
            <View style={style.cardContentStyle}>
              <Calendar
                style={style.calendarStyle}
                theme={{
                  calendarBackground: style.calendarBackgroundStyle(theme).color,
                  monthTextColor: style.monthTitleStyle(theme).color,
                  textMonthFontFamily: style.monthTitleStyle(theme).fontFamily,
                  textMonthFontSize: style.monthTitleStyle(theme).fontSize,
                  textSectionTitleColor: style.dayNamesStyles(theme).color,
                  textDayHeaderFontFamily: style.dayNamesStyles(theme).fontFamily,
                  textDayHeaderFontSize: style.dayNamesStyles(theme).fontSize,
                  todayTextColor: style.daysNumbersStyles(theme).color,
                  dayTextColor: style.daysNumbersStyles(theme).color,
                  textDayFontFamily: style.daysNumbersStyles(theme).fontFamily,
                  textDayFontSize: style.daysNumbersStyles(theme).fontSize,
                  textDisabledColor: style.disabledDaysNumbersStyles.color,
                  selectedDayBackgroundColor: 'transparent',
                  selectedDayTextColor: 'rgb(175, 175, 175)'
                }}
                minDate={moment().add(1, 'day').format('YYYY-MM-DD')}
                maxDate={moment().add(5, 'day').format('YYYY-MM-DD')}
                onDayPress={day => {
                  this.setState({
                    selectedDate: day.dateString,
                    selectedTime: '',
                  })
                  onSelectDateAndTimePress(day.dateString)
                }}
                monthFormat={'MMMM yyyy'}
                hideExtraDays={false}
                firstDay={1}
                disableAllTouchEventsForDisabledDays={true}
                markingType={'custom'}
                markedDates={{
                  [this.state.selectedDate]: {
                    customStyles: {
                      text: style.calendarSelectedDateTextStyle(theme),
                      container: {
                        backgroundColor: theme.colors.radioButton,
                      },
                    },
                  },
                }}
                renderArrow={direction => (
                  <Icon
                    name={
                      direction === 'right'
                        ? Images.ic_chevron_right_black_white
                        : Images.ic_chevron_left_black_white
                    }
                    type="image"
                    style={style.calendarArrowStyle(direction)}
                  />
                )}
              />
            </View>
          )}
        </Card>
      </ScrollView>
    )
  }
}

DateStep.defaultProps = {
  theme: LightThemeColors,
  onSelectDateAndTimePress: () => { },
}

DateStep.propTypes = {
  theme: PropTypes.object,
  isLoading: PropTypes.bool,
  dates: PropTypes.object,
  onSelectDateAndTimePress: PropTypes.func,
  withTray: PropTypes.bool,
  selectedDate: PropTypes.string,
  selectedTime: PropTypes.string,
}

export default withTheme(DateStep)
